<template>
    <div>
        <div class="award-divider">
            <span class="divider-line"></span>
            <span class="divider-text">our awards</span>
            <span class="divider-line"></span>
        </div>
        <div class='awards-container'>
            <div class='award-card'>
                <img class='award-image' src="@/ecom/assets/images/footer/iwc-award-2024.png">
            </div>
            <div class='award-card'>
                <img class='award-image' src="@/ecom/assets/images/footer/drinks-reatailing-awards.png">
            </div>
            <div class='award-card'>
                <img class='award-image' src="@/ecom/assets/images/footer/drinks-business-award-2025.png">
            </div>
            <div class='award-card'>
                <img class='award-image' src="@/ecom/assets/images/footer/decanter_2023.png">
            </div>
            <div class='award-card'>
                <img class='award-image' src="@/ecom/assets/images/footer/retail-week-award.png">
            </div>
        </div>
        <div class="award-separator"></div>
    </div>
</template>
<style lang="scss" scoped>
.award-divider {
    display: flex;
    align-items: center;
    text-align: center;
}
.divider-line {
    flex: 1;
    border-top: 1px solid var(--maj-dark-green);
}
.divider-text {
    padding: 0 10px;
    text-transform: uppercase;
    font-size: 1.31rem;
    white-space: nowrap;
    color: var(--maj-dark-green);
}

.award-separator{
    border-bottom: 1px solid var(--maj-dark-green);
}
.awards-container{
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top:36px;
    margin-bottom: 36px;

    @media(max-width: 768px){
        margin-bottom: 40px;
        justify-content: center;
        gap: 12px;
    }
}
.award-image{
    height: 110px;
    margin: auto;
}
.award-image-1{
    width: 60px;
}
</style>